export default __webpack_public_path__ + "img/logo-scholarshipowl-footer.e2f43b2.svg";